export default {
    // 门户
    "threeWeb":'https://www.zengcaicloud.com',
    // 卖家中心
    "sellerWeb":'https://seller.zengcaicloud.com',
    // 设计师中心
    "designerWeb":'https://designer.zengcaicloud.com',
    // 跳转支付页面
    "payUrl":'https://www.zengcaicloud.com/resource-pay/pay/',
}



// WEBPACK FOOTER //
// ./src/utils/url.js